'use client';

import { useEffect } from 'react';
import { CUSTOM_FONT_VAR_PREFIX, isCustomFont } from '../../../utils/fonts';

export default function FontLoaderWrapper({ settings, fonts }) {
	useEffect(() => {
		const googleFonts = [
			settings.fontFamily,
			settings.headingFontFamily,
			...Object.keys(settings)
				.filter((k) => k.startsWith(CUSTOM_FONT_VAR_PREFIX))
				.map((k) => settings[k]),
		].filter((v) => v && !isCustomFont(v));

		if (googleFonts.length > 0) {
			import('webfontloader').then((WebFont) => {
				WebFont.load({
					google: { families: googleFonts.map((f) => `${f}:400,500,600,700`) },
				});
			});
		}
		fonts.forEach((font) => {
			const fontUrl = `/api/fonts/${font.id}`;
			const fontFace = new FontFace(`customFont-${font.name}`, `url(${fontUrl})`);
			fontFace.load().then(() => document.fonts.add(fontFace));
		});
	});

	return null;
}
